import { useState, useContext, useMemo } from "react";
import { Modal, Button } from "react-bootstrap";
import { T } from "react-translator-component";
import { termAndConditionsText } from "./TermAndConditionsText";
import { HotelContext } from "../../context/hotel";
import { CheckInContext } from "../../context/checkin";
import { getPropertyTermsAndConditionsPlaceholderText } from "./hotelTermsAndConditionsPlaceholder";
import { hotelRegulationsText } from "./HotelRegulations-Costa";
import { hotelRegulationsText as hr_belair } from "./HotelRegulations-BelAir";
import { hotelRegulationsText as hr_hostz } from "./HotelRegulations-Hostz-blacksummit";
import { hotelRegulationsText as hr_hostz_becoze } from "./HotelRegulations-Hostz-becozy";
import { hotelRegulationsText as hr_hostz_sancarlo } from "./HotelRegulations-Hostz-sancarlo";
import { hotelRegulationsText as hr_hostz_betahouse } from "./HotelRegulations-Hostz-betahouse";
import { hotelRegulationsText as hr_hostz_themyde } from "./HotelRegulations-Hostz-themyde";
import { hotelRegulationsText as hr_hostz_arosa } from "./HotelRegulations-Hostz-arosa";
import { hotelRegulationsText as hr_hostz_cozy } from "./HotelRegulations-Hostz-cozy";
import { hotelRegulationsText as hr_hostz_swissstay } from "./HotelRegulations-Hostz-swissstay";
import { hotelRegulationsText as hr_hostz_steiners } from "./HotelRegulations-Hostz-steiners";
import { hotelRegulationsText as hr_offgrid } from "./HotelRegulations-offgrid";
import { hotelRegulationsText as hr_simplex } from "./HotelRegulations-simplex";
import { hotelRegulationsText as hr_hostz_sigma } from "./HotelRegulations-Hostz-sigma";

import { isCostaGalana, isHostz, isHostzBecozy, isHostzBlackSummit, isHostzSanCarlo, isOffgrid, isHostzBetaHouse, isHostzMyde, isHostzArosa, isBelAir, isHostzCozy, isHostzSwissstay, isHostzSteiners, isSimplex, isHostzSigma } from "./hotelConditions";
import processHtml from '../../components/processHtml';


const TermsAndConditionsModal = ({ language, showIsForeignMsg }) => {

    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const { data, placeholders: hotelPlaceholders } = useContext(HotelContext);
    const { data: checkIn } = useContext(CheckInContext);

    const handleOpenModal = () => {
        setShow(true);
    }
    const handleOpenModal2 = () => {
        setShow2(true);
    }
    const handleOpenModal3 = () => {
        setShow3(true);
    }

    const handleCloseModal = () => {
        setShow(false);
    }
    const handleCloseModal2 = () => {
        setShow2(false);
    }
    const handleCloseModal3 = () => {
        setShow3(false);
    }

    // const isCostaGalana = useMemo(
    //     () => (
    //         data.id === "1de880e5-bfb6-4518-bd1b-095443bbc58b" ||      // prd
    //         data.id === "8b91c3ba-6ef0-4667-805b-30b51f378ca5"         // dev
    //     ),
    //     [data.id]
    // );

    const text = termAndConditionsText[data?.id] || termAndConditionsText["VICO-TERMS"];
    const translatedText = text[language] || T("checkin.terms-and-conditions-text");
    const text2 = hotelRegulationsText;
    let translatedText2 = processHtml(text2[language]);

    const phText = getPropertyTermsAndConditionsPlaceholderText(
        language,
        hotelPlaceholders,
        checkIn?.placeholders
    );
    if (phText) {
        translatedText2 = processHtml(phText);
    } else if (isBelAir(data?.id)) {
        translatedText2 = processHtml(hr_belair?.[language] || hr_belair?.["es-ES"] || "")
    } else if (isHostzBlackSummit(data?.id)) {
        translatedText2 = processHtml(hr_hostz?.[language] || hr_hostz?.["en-US"] || "")
    } else if (isHostzBecozy(data?.id)) {
        translatedText2 = processHtml(hr_hostz_becoze?.[language] || hr_hostz_becoze?.["en-US"] || "")
    } else if (isHostzSanCarlo(data?.id)) {
        translatedText2 = processHtml(hr_hostz_sancarlo?.[language] || hr_hostz_sancarlo?.["en-US"] || "")
    } else if (isHostzBetaHouse(data?.id)) {
        translatedText2 = processHtml(hr_hostz_betahouse?.[language] || hr_hostz_betahouse?.["en-US"] || "")
    } else if (isHostzMyde(data?.id)) {
        translatedText2 = processHtml(hr_hostz_themyde?.[language] || hr_hostz_themyde?.["en-US"] || "")
    } else if (isHostzArosa(data?.id)) {
        translatedText2 = processHtml(hr_hostz_arosa?.[language] || hr_hostz_arosa?.["en-US"] || "")
    } else if (isHostzCozy(data?.id)) {
        translatedText2 = processHtml(hr_hostz_cozy?.[language] || hr_hostz_cozy?.["en-US"] || "")
    } else if (isHostzSwissstay(data?.id)) {
        translatedText2 = processHtml(hr_hostz_swissstay?.[language] || hr_hostz_swissstay?.["en-US"] || "")
    } else if (isHostzSteiners(data?.id)) {
        translatedText2 = processHtml(hr_hostz_steiners?.[language] || hr_hostz_steiners?.["en-US"] || "")
    } else if (isOffgrid(data?.id)) {
        translatedText2 = processHtml(hr_offgrid?.[language] || hr_offgrid?.["en-US"] || "")
    } else if (isSimplex(data?.id)) {
        translatedText2 = processHtml(hr_simplex?.[language] || hr_simplex?.["de"] || "")
    } else if (isHostzSigma(data?.id)) {
        translatedText2 = processHtml(hr_hostz_sigma?.[language] || hr_hostz_sigma?.["en-US"] || "")
    }
    return (
        <>
            <p className="font-size-sm mt-3 mb-3 text-center p-1">

                {
                    isOffgrid(data?.id)
                        ?
                        <>
                            {T("checkin.gdpr-text1-offgrid")}
                            {` `}
                            <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal}>
                                {T("checkin.gdpr-button")}
                            </Button>
                            {T("checkin.gdpr-text-nexo-offgrid")}
                            <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal2}>
                                {T("checkin.terms-and-conditions")}
                            </Button>
                            {T("checkin.gdpr-text2-offgrid")}
                        </>
                        :
                        isHostz(data?.id)
                            ?
                            <>
                                {T("checkin.gdpr-text1-hostz")}
                                {` `}
                                <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal}>
                                    {T("checkin.gdpr-button")}
                                </Button>
                                {T("checkin.gdpr-text-nexo-hostz")}
                                <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal2}>
                                    {!isHostzSwissstay(data?.id) ? T("checkin.gdpr-button-1-hostz") : T("checkin.gdpr-button-1-hostz-swissstay")}
                                </Button>
                                {T("checkin.gdpr-text2-hostz")}
                            </>
                            :
                        isSimplex(data?.id)
                            ?
                            <>
                                {T("checkin.gdpr-text1-simplex")}
                                {` `}
                                <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal}>
                                    {T("checkin.gdpr-button")}
                                </Button>
                                {T("checkin.gdpr-text-nexo-simplex")}
                                <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal2}>
                                    {T("checkin.gdpr-button-1-simplex")}
                                </Button>
                                {T("checkin.gdpr-text2-simplex")}
                            </>
                            :
                            (isCostaGalana(data?.id) || isBelAir(data?.id))
                                ?
                                <>
                                    {T("checkin.gdpr-text1-costa")}
                                    {` `}
                                    <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal}>
                                        {T("checkin.gdpr-button")}
                                    </Button>
                                    {T("checkin.gdpr-text-nexo-costa")}
                                    <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal2}>
                                        {T("checkin.gdpr-button-1")}
                                    </Button>
                                    {showIsForeignMsg && (
                                        <>
                                            {T("checkin.gdpr-text2-costa")}
                                            {` `}
                                            <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal3}>
                                                {T("checkin.gdpr-button-2")}
                                            </Button>
                                            {/* <br></br><br></br>
                                            {T("checkin.gdpr-text3-costa")} */}
                                        </>
                                    )}
                                    {!showIsForeignMsg && (
                                        <>
                                            {`.`}
                                        </>
                                    )}
                                </>
                                :
                                <>
                                    {T("checkin.gdpr-text1")}
                                    {` `}
                                    <Button variant="link" className="font-size-sm" style={{ display: "inline", verticalAlign: "baseline", padding: 0, border: "none", background: "none" }} onClick={handleOpenModal}>
                                        {T("checkin.gdpr-button")}
                                    </Button>
                                    {` `}
                                    {T("checkin.gdpr-text2")}
                                </>
                }
            </p>

            <Modal show={show} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    {isOffgrid(data?.id) ? T("checkin.gdpr-button") : T("checkin.terms-and-conditions")}
                </Modal.Header>
                <Modal.Body>
                    <p className="font-size-sm mb-3 text-center">
                        <p className="font-size-sm mb-3 text-justify" style={{ whiteSpace: "break-spaces" }}>
                            {translatedText}
                        </p>
                    </p>
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleCloseModal}>
                            {T("general.close")}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={show2} onHide={handleCloseModal2}>
                <Modal.Header closeButton>
                    {isOffgrid(data?.id) ? T("checkin.terms-and-conditions") : T("checkin.hotel-regulations")}
                </Modal.Header>
                <Modal.Body>
                    <div className="font-size-sm mb-3 text-justify" style={{ whiteSpace: "break-spaces" }}>{translatedText2}</div>
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleCloseModal2}>
                            {T("general.close")}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={show3} onHide={handleCloseModal3}>
                <Modal.Header closeButton>
                    {T("checkin.gdpr-button-2")}
                </Modal.Header>
                <Modal.Body>
                    <div className="font-size-sm mb-3 text-justify" style={{ whiteSpace: "break-spaces" }}>{T("checkin.gdpr-button-2-popup")}</div>
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleCloseModal3}>
                            {T("general.close")}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default TermsAndConditionsModal;
